import React from 'react';
import { EnquiryComponent } from '@vivli/features/enquiry/components';
import { EnquiryContextWrapper } from '@vivli/features/enquiry/infastructure/wrappers';
import { useEnquiryFormHook, useEnquiry } from '@vivli/features/enquiry/infastructure/hook';
import { FormProvider } from 'react-hook-form';

export const EnquiryFeature = () => {
    const { enquiry, setEnquiry } = useEnquiry();
    const formApi = useEnquiryFormHook(enquiry);

    //the effect that reset the form from the enquiry used to live here. It moved into
    //EnquiryContextWrapper so it can be guarded on the form's dirty state - adding a comment calls
    //setEnquiry, and an unguarded reset would fold that comment into defaultValues and clear dirty
    //a tick after the comment was recorded, leaving Save disabled over unsaved work.

    return (
        <FormProvider {...formApi}>
            <EnquiryContextWrapper enquiry={enquiry} setEnquiry={setEnquiry}>
                <EnquiryComponent />
            </EnquiryContextWrapper>
        </FormProvider>
    );
};
